export default __webpack_public_path__ + "assets/audio/totokanaikoi.ce49ebb5.m4a";